<template>
  <div id="goodsedit">
    <div class="goodsAddBlock">
      <el-form
        id="gForm"
        ref="gForm"
        size="small"
        :model="gForm"
        :rules="formRule"
        label-position="top"
      >
        <el-form-item class="input" prop="goods_name">
          <label class="lb">
            <span>*</span>{{$t("goods_name")}}
          </label>
          <el-input class="input_normal" size="small" v-model="gForm.goods_name"></el-input>
        </el-form-item>
        <el-form-item class="input" prop="price" v-if="goodsMode!='solrx'">
          <label class="lb">
            <span></span>{{$t("goods_price")}}
          </label>
          <el-input class="input_normal" size="small" v-model="gForm.price"></el-input>
        </el-form-item>
        <el-form-item class="input" prop="goods_pic">
          <label class="lb">
            <span>*</span>{{$t("goods_img")}}
          </label>
          <el-upload
            class="avatar-uploader"
            action="/fileSvr/put"
            name="name"
            :data="{ app_name: 'conf_app' }"
            :show-file-list="false"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload"
          >
            <img v-if="gForm.goods_pic" :src="managerImg(gForm.goods_pic)" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item class="input" prop="for_sex" v-if="goodsMode!='solrx'">
          <label class="lb">
            <span>*</span>{{$t("goods_for_person")}}
          </label>
          <el-radio-group size="mini" v-model="gForm.for_sex">
            <el-radio-button size="mini" :label="1">{{$i18n.t('sex')[0]}}</el-radio-button>
            <el-radio-button size="mini" :label="2">{{$i18n.t('sex')[1]}}</el-radio-button>
            <el-radio-button size="mini" :label="0">{{$i18n.t('sex')[2]}}</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item class="input" prop="type_ids" v-if="goodsMode!='solrx'">
          <label class="lb">
            <span>*</span>{{$t("goods.goods_effects")}}
          </label>
          <el-checkbox-group class="checkboxContent" v-model="type_id_arr" @change="handleCheckedTypesChange">
            <el-checkbox v-for="(goodtype, i) in typeList" :label="goodtype.id" :key="i">{{goodtype.type_name}}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item class="input" prop="tag" v-if="goodsMode=='solrx'">
          <label class="lb">
            <span>*</span>{{$t("goods.goods_tags")}}
          </label>
          <el-input class="input_normal" size="small" v-model="gForm.tag" maxlength="3" show-word-limit/>
        </el-form-item>
        <el-form-item class="input" prop="ext_rules.skin_type" v-if="goodsMode=='solrx'">
          <label class="lb">
            <span>*</span>{{$t("goods.skin_type")}}
          </label>
          <el-radio-group size="mini"  v-model="gForm.ext_rules.skin_type">
            <el-radio-button size="mini" label="oil">{{$i18n.t('goods.skin_type_result.oil')}}</el-radio-button>
            <el-radio-button size="mini" label="dry">{{$i18n.t('goods.skin_type_result.dry')}}</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item class="input" prop="ext_rules.sensitive" v-if="goodsMode=='solrx'">
          <label class="lb">
            <span>*</span>{{$t("goods.sensitive")}}
          </label>
          <el-radio-group size="mini"  v-model="gForm.ext_rules.sensitive">
            <el-radio-button size="mini" label="1">{{$i18n.t('goods.sensitive_result.1')}}</el-radio-button>
            <el-radio-button size="mini" label="0">{{$i18n.t('goods.sensitive_result.0')}}</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item class="input" prop="ext_rules.pigment" v-if="goodsMode=='solrx'">
          <label class="lb">
            <span>*</span>{{$t("goods.pigment")}}
          </label>
          <el-radio-group size="mini"  v-model="gForm.ext_rules.pigment">
            <el-radio-button size="mini" label="1">{{$i18n.t('goods.pigment_result.1')}}</el-radio-button>
            <el-radio-button size="mini" label="0">{{$i18n.t('goods.pigment_result.0')}}</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item class="input" prop="ext_rules.wrinkle" v-if="goodsMode=='solrx'">
          <label class="lb">
            <span>*</span>{{$t("goods.wrinkle")}}
          </label>
          <el-radio-group size="mini" v-model="gForm.ext_rules.wrinkle">
            <el-radio-button size="mini" label="1">{{$i18n.t('goods.wrinkle_result.1')}}</el-radio-button>
            <el-radio-button size="mini" label="0">{{$i18n.t('goods.wrinkle_result.0')}}</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item class="input" prop="source_url" v-if="is_rizap">
          <label class="lb">
            {{$t("goods.source_url")}}
          </label>
          <el-input style="width: 500px" class="input_normal" size="small" v-model="gForm.source_url"></el-input>
        </el-form-item>
        <el-form-item class="input" prop="content">
          <label class="lb">
            <span></span>{{$t("goods_detail")}}
          </label>
          <quilleditor
            class="editerBox"
            v-model="gForm.content"
            ref="myTextEditor"
            :options="editorOption"
            @change="onChange"
          >
            <div id="toolbar" slot="toolbar">
              <select class="ql-size">
                <option value="small"></option>
                <option selected></option>
                <option value="large"></option>
                <option value="huge"></option>
              </select>
              <span class="ql-formats">
                <button class="ql-script" value="sub"></button>
              </span>
              <span class="ql-formats">
                <button class="ql-script" value="super"></button>
              </span>
              <span class="ql-formats">
                <button type="button" class="ql-bold"></button>
              </span>
              <span class="ql-formats">
                <button type="button" class="ql-italic"></button>
              </span>
              <span class="ql-formats">
                <button type="button" class="ql-blockquote"></button>
              </span>
              <span class="ql-formats">
                <button type="button" class="ql-list" value="ordered"></button>
              </span>
              <span class="ql-formats">
                <button type="button" class="ql-list" value="bullet"></button>
              </span>
              <span class="ql-formats">
                <button type="button" class="ql-link"></button>
              </span>
              <span class="ql-formats">
                <button type="button" @click="imgClick" style="outline:none">
                  <svg viewBox="0 0 18 18">
                    <rect class="ql-stroke" height="10" width="12" x="3" y="4" />
                    <circle class="ql-fill" cx="6" cy="7" r="1" />
                    <polyline
                      class="ql-even ql-fill"
                      points="5 12 5 11 7 9 8 10 11 7 13 9 13 12 5 12"
                    />
                  </svg>
                </button>
              </span>
            </div>
          </quilleditor>
        </el-form-item>
        <el-form-item class="input" prop="submit">
          <el-button
            class="btn1 submitbtn"
            type="primary"
            @click="preSubmit()"
          >{{$t("normal_sure")}}</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";
export default {
  name: "goodsedit",
  props: {
    value: {
      type: String
    },
    uploadUrl: {
      type: String,
      default: "/fileSvr/put"
    },
    fileName: {
      type: String,
      default: "name"
    },
    maxUploadSize: {
      type: Number,
      default: 1024 * 1024 * 2048
    }
  },
  data() {
    return {
      is_rizap: true,
      skinlist: [],
      title: "",
      doing: false,
      editorOption: {
        theme: "snow",
        modules: {
          toolbar: "#toolbar"
        }
      },
      gForm: {
        id: "",
        goods_name: "",
        price: "",
        goods_pic: "",
        type_ids: "",
        for_sex: "0",
        source_url: "",
        content: "<p>hello world</p>",
        ext_rules: {
        }
      },
      typeList: null,
      type_id_arr: [],
      formRule: {
        goods_name: [
          { required: true, message: this.$i18n.t('field_empty'), trigger: "blur" }
        ],
        goods_pic: [
          { required: true, message: this.$i18n.t('field_empty'), trigger: "blur" }
        ],
        type_ids: [
          { required: true, message: this.$i18n.t('field_empty'), trigger: "blur" }
        ],
        for_sex: [
            { required: true, message: this.$i18n.t('field_empty'), trigger: "blur" }
        ],
        tag: [
            { required: true, message: this.$i18n.t('field_empty'), trigger: "blur" }
        ],
        'ext_rules.skin_type': [
            { required: true, message: this.$i18n.t('field_empty'), trigger: "blur" }
        ],
        'ext_rules.sensitive': [
            { required: true, message: this.$i18n.t('field_empty'), trigger: "blur" }
        ],
        'ext_rules.pigment': [
            { required: true, message: this.$i18n.t('field_empty'), trigger: "blur" }
        ],
        'ext_rules.wrinkle': [
            { required: true, message: this.$i18n.t('field_empty'), trigger: "blur" }
        ]
      },
      configStype: 1,
      pushType: "1",
      goodsMode: null
    };
  },
  components: {
    quilleditor: quillEditor
  },
  computed: {
    editor() {
      return this.$refs.myTextEditor.quill;
    }
  },
  mounted() {
    if(this.value){
      this.gForm.content = this.value
    }
    this.title = this.$i18n.t('goods_add')
    this.initConf()
  },
  watch: {
    value(newVal, oldVal) {
      if (this.editor) {
        if (newVal !== this.gForm.content) {
          this.gForm.content = newVal
        }
      }
    },
    goodsMode(cur, oldVal) {
        if(cur=='solrx'){
            this.formRule['type_ids'][0].required = false
            this.formRule['for_sex'][0].required = false
            this.formRule['ext_rules.skin_type'][0].required = true
            this.formRule['ext_rules.sensitive'][0].required = true
            this.formRule['ext_rules.pigment'][0].required = true
            this.formRule['ext_rules.wrinkle'][0].required = true
        }else{
            this.formRule['type_ids'][0].required = true
            this.formRule['for_sex'][0].required = true
            this.formRule['ext_rules.skin_type'][0].required = false
            this.formRule['ext_rules.sensitive'][0].required = false
            this.formRule['ext_rules.pigment'][0].required = false
            this.formRule['ext_rules.wrinkle'][0].required = false
        }
    }
  },
  created() {
    if (localStorage.edit_goods_id && localStorage.edit_goods_id > 0) {
      this.gForm.id = localStorage.edit_goods_id;
      this.title = this.$i18n.t('goods_edit');
    }
    this.getGoodsTypes()
    this.getGoods()
  },
  methods: {
    managerImg(filename){
      if(filename.indexOf('http') != -1){
        return filename
      }
      return '/fileSvr/get/'+ filename
    },
    initConf() {
        let _this = this
        if(localStorage.userConfs){
            let confs = JSON.parse(localStorage.userConfs)
            if(confs.goods_mode){
                _this.goodsMode = confs.goods_mode
            }
        }
        let data = {
            code: 'platform'
        };
        this.axios.post("/skinMgrSrv/config/get", this.formData(data)).then(function(response) {
          if (response.data.code === 0) {
            if(response.data.platform&&response.data.platform=='rizap') {
              _this.is_rizap = true
            }
          }
        }).catch(function (res) {
          console.error(res)
        });
    },
    handleCheckedTypesChange(value){
      if(value.length > 3){
        this.$message(this.$i18n.t('selectmost'))
		var arr = new Array()
		for(var i=0; i < 3; i++){
			arr.push(this.type_id_arr[i])
		}
        this.type_id_arr = arr
      }
	  this.gForm.type_ids = this.type_id_arr.join(',')
	  console.log(this.gForm.type_ids)
    },
    cnumber(i){
      if(i<10){
        return '0'+i;
      }
      return ''+i;
    },
    onChange() {
      this.$emit("input", this.gForm.content);
    },
    onFileChange(e) {
      let fileInput = e.target;
      if (fileInput.files.length === 0) {
        return;
      }
      if (fileInput.files[0].size > this.maxUploadSize) {
        this.$alert(
          this.$i18n.t("imagelimit2m"),
          this.$i18n.t("imagelimit2big"),
          {
            confirmButtonText: this.$i18n.t("normal_sure"),
            type: "warning"
          }
        );
      }
      let config = {
        headers: { "Content-Type": "multipart/form-data" }
      };
      let data = new FormData();
      data.append(this.fileName, fileInput.files[0]);
      data.append('app_name', 'conf_app');
      let _this = this;
      this.axios.post(this.uploadUrl, data, config).then(function(response) {
        if (response.data) {
          let ii = _this.editor.getSelection()
            ? _this.editor.getSelection().index
            : 0;
		  let allurl = response.data.img_path
		  if(allurl.indexOf('http') == -1){
			  allurl = '/fileSvr/get/' + allurl
		  }
          _this.editor.insertEmbed(ii, "image", allurl);
        }
      });
    },
    imgClick() {
      if (!this.uploadUrl) {
        console.log("no editor uploadUrl")
        return
      }
      let input = document.createElement("input")
      input.type = "file"
      input.name = this.fileName
      input.accept = "image/jpeg,image/png,image/jpg,image/gif"
      input.onchange = this.onFileChange
      input.click()
    },
    preSubmit() {
      let _this = this
      this.$refs["gForm"].validate(valid => {
        if (valid) {
          _this.submit()
        } else {
          console.log("error!")
          return false
        }
      })
    },
    managerContentPicurl(content){
      const url = new URL(window.location.href);  
      const hostname = url.hostname; // 这将返回不带协议的域名  
      let host = ''
      if( 
        hostname.indexOf("yimei") > -1 || 
        hostname.indexOf("yiyuan") > -1 ||
        hostname.indexOf("bitmoji") > -1
      ){
        host = 'https://' + hostname
      }
      if( 
        hostname.indexOf("localhost") > -1 || 
        hostname.indexOf("127") > -1
      ){
        host = 'https://test.yimei.ai'
      }
      if(host != ''){
        let replaceStr = '"' + host + '/fileSvr/get'
        content = content.replace(/\"\/fileSvr\/get/g, replaceStr)
      }
      return content
    },
    submit() {
      if (this.doing === true) {
        return false
      }
      this.doing = true
      let _this = this
      let data = {}
      Object.assign(data,this.gForm)
      if(data.ext_rules){
          data.ext_rules = JSON.stringify(data.ext_rules)
      }
      data.content = this.managerContentPicurl(data.content)

      this.axios
        .post("/skinMgrSrv/goods/edit", this.formData(data))
        .then(function(response) {
          _this.doing = false
          if (response.data.msg) {
            _this.$message(response.data.msg)
          }
          if (response.data.code === 0) {
            localStorage.edit_goods_id = 0;
            _this.$message(_this.$i18n.t("support_success"))
            localStorage.activeMenu = _this.$i18n.t("goods_manager")
            _this.$router.push({ path: "/skinmgr/goodsList" })
          }
          console.log(response.data)
        })
    },
    cansal() {
      localStorage.activeMenu = this.$i18n.t("goods_manager")
      this.$router.push({ path: "/skinmgr/goodsList" })
    },
    onEditorReady(editor) {
    },
    onEditorBlur() {}, // 失去焦点事件
    onEditorFocus() {}, // 获得焦点事件
    onEditorChange() {}, // 内容改变事件
    saveHtml: function(event) {
      alert(this.content);
    },
    getGoods() {
      if (
        !localStorage.edit_goods ||
        localStorage.edit_goods === -1 ||
        localStorage.edit_goods === "-1"
      ) {
        localStorage.edit_goods = ""
        this.gForm.id = ""
        return false
      }
      var goodsInfo = JSON.parse(localStorage.edit_goods)

	    console.log('--------goodsInfo.type_ids-----------')
      if(goodsInfo.type_ids){
		    let tempids = goodsInfo.type_ids.split(',')
        this.type_id_arr = []
        for(let ijk in tempids){
          this.type_id_arr.push(parseInt(tempids[ijk]))  
        }
         
      }
	    console.log('--------goodsInfo.type_ids-----------', this.type_id_arr)
      if(!goodsInfo.ext_rules){
          goodsInfo.ext_rules = {}
      }
      this.gForm=goodsInfo
      console.log('this.gForm', this.gForm)
    },
    handleAvatarSuccess(res, file) {
      this.gForm.goods_pic = URL.createObjectURL(file.raw)
      console.log( 'res', res )
      if (res.code == 10000) {
        this.gForm.goods_pic = res.img_path
      }
      
    },
    beforeAvatarUpload(file) {
      //const isJPG = file.type === "image/jpeg"
      const isLt2M = file.size / 1024 / 1024 < 2

      // if (!isJPG) {
      //   this.$message.error(this.$i18n.t("image_fix_tips"))
      // }
      if (!isLt2M) {
        this.$message.error(this.$i18n.t("image_big_tips_2"))
      }
      return isLt2M
    },
    getGoodsTypes(){
	  let sessionkey = 'goodsTypeList-'+localStorage.locale
      if(sessionStorage.getItem(sessionkey)){
        this.typeList = JSON.parse(sessionStorage.getItem(sessionkey))
        return true
      }
      if (this.doing === true) {
        return false
      }
      this.doing = true
      let _this = this
      this.axios.post('/skinMgrSrv/goods/typeList', {}).then(function (response) {
        _this.doing = false
        if (response.data.code === 0) {
          _this.typeList = response.data.list
		  sessionStorage.setItem(sessionkey, JSON.stringify(_this.typeList))
        }
      }).catch(function (res) {
          _this.doing = false
      })
    }
  }
};
</script>
<style  lang="scss">
#goodsedit {
  .tabs-container {
    .el-card__header {
      padding: 0.0833rem 0.1667rem !important;
    }
    .el-card {
      cursor: pointer;
    }
    .el-card:hover {
      border: $blue 1px solid;
    }
  }
  .el-dialog__header {
    border-bottom: #e9e9e9 1px solid !important;
  }
  .el-form-item__error {
    margin-left: 128px;
  }
  .el-button--primary {
    color: #fff;
    background-color: #57AEC9;
    border-color: #57AEC9;
  }
  .is-checked {
    span{
      color: #fff;
    }
    color: #fff;
    background-color: #57AEC9;
    border-color: #57AEC9;
    -webkit-box-shadow: -1px 0 0 0 #57AEC9;
    box-shadow: -1px 0 0 0 #57AEC9;
  }
  .avatar-uploader-icon {
    border: 1px solid #ccc;
  }
  .el-checkbox-group {
    display: inline-block;
  }
  .el-checkbox-button.is-checked .el-checkbox-button__inner {
    background-color: #57AEC9;
    border-color: #57AEC9;
    -webkit-box-shadow: -1px 0 0 0 #57AEC9;
    box-shadow: -1px 0 0 0 #57AEC9;
  }
  .el-checkbox__inner {
    display: none;
  }
  .el-checkbox__label {
    padding-left: 0px;
  }
  .ql-container.ql-snow {
    min-height: 250px;
  }
  .checkboxContent{
    width: 8rem;
    max-width: 8rem;
  }
  .el-checkbox {
    margin-right: 5px;
    margin-top: 5px;
    border: 1px solid #ccc;
    border-radius: 3px;
    width: auto;
	padding-left: 8px;
	padding-right: 8px;
    text-align: center;
    font-size: 12px;
  }
  .el-radio-button__inner{
    border: 0px;
    width: auto;
	padding-left: 8px;
	padding-right: 8px;
    background-color: #fff;
  }
  .el-radio-button{
    margin-right: 5px;
    margin-top: 5px;
    border: 1px solid #ccc;
    border-radius: 3px;
    width: auto;
    padding-left: 8px;
    padding-right: 8px;
    text-align: center;
    font-size: 12px;
  }

  .is-active {
    span{
      color: #fff;
    }
    color: #fff;
    background-color: #57AEC9;
    border-color: #57AEC9;
    -webkit-box-shadow: -1px 0 0 0 #57AEC9;
    box-shadow: -1px 0 0 0 #57AEC9;
  }

  .el-radio-button__orig-radio:checked+.el-radio-button__inner {
    background-color: #57AEC9;
    border-color: #57AEC9;
    -webkit-box-shadow: -1px 0 0 0 #57AEC9;
    box-shadow: -1px 0 0 0 #57AEC9;
  }
}
</style>

<style scoped lang="scss">
#goodsedit {
  margin: 0.1667rem;
  box-sizing: border-box;
  background-color: #fff;
  border-radius: 0.04166rem;
  padding: 0.166rem;
  .goodsAddBlock {
    width: calc(100% - 0.11rem);
    min-height: 3.6rem;
    height: auto;
    display: block;
    margin-top: 0.0833rem;
    #gForm {
      width: calc(100% - 0.11rem);
      .submitbtn {
        margin-left: 1.2rem;
        width: 0.7rem;
      }
    }
  }
  .el-input .workfor {
    width: 1.25rem;
  }
  .input_normal {
    width: 2.5rem;
  }
  label.lb {
    width: 1.2rem;
    text-align: right;
    display: inline-block;
    margin-right: 0.1667rem;
    vertical-align: top;
    span {
      color: red;
    }
  }
  .tarea {
    margin-left: 0rem;
    width: 10rem;
  }
  .quill-editor {
    margin-left: 0rem;
    width: 8rem;
    min-height: 300px;
    display: inline-block;
  }
  .avatar-uploader {
    display: inline-block;
    width: 1rem;
    height: 1rem;
    margin-top: 10px;
  }
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 1rem;
    height: 1rem;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 1rem;
    height: 1rem;
    line-height: 1rem;
    text-align: center;
  }
  .avatar {
    width: 1rem;
    height: 1rem;
    display: block;
    border: 1px solid #ccc;
  }
}
</style>



// WEBPACK FOOTER //
// src/goods/edit.vue